import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

function getLoginPath(userType) {
  if (userType === "ADMIN") return "/job/admin/login";
  return `${process.env.PUBLIC_URL || ""}/${userType.toLowerCase()}/auth/login`;
}

function ProtectedRoute({ userType, children }) {
  const { user } = useContext(AuthContext);
  const token = localStorage.getItem("_token");

  if (!token) {
    return (
      <Navigate to={getLoginPath(userType)} replace />
    );
  }

  const userData = JSON.parse(localStorage.getItem("user_data") || "{}");
  if (userData.type !== userType) {
    return (
      <Navigate to={getLoginPath(userData.type || userType)} replace />
    );
  }

  return children;
}

export default ProtectedRoute;
